import React from 'react';
import useCookie from 'src/hooks/useCookie';
import { useEffect } from 'react';
import { COOKIES } from 'src/context/constants';
import { readDefaultBroker } from 'src/utils/utils';
import { useHistory } from 'react-router-dom';
import LoadingScreen from './LoadingScreen';
import useRouteManager from 'src/utils/customHook/useRouteManager';


interface ComponentSectionProps {

}
const RedirectDefaultBroker: React.FC<ComponentSectionProps> = () => {

  const { getCookie } = useCookie()
  const history = useHistory();
  const { saveBroker } = useRouteManager();

  useEffect(()=>{
    let ltb = getCookie(COOKIES.latestSelBroker,false)
    let dfb:string = ltb || readDefaultBroker() || "ENV_RDB078"
    dfb = dfb.toLowerCase()
    saveBroker(dfb || "")
    history.replace(`/${dfb}/home`)
  },[getCookie,history,saveBroker])

  return (
    <LoadingScreen/>
  )
}

export default RedirectDefaultBroker;
